// extracted by mini-css-extract-plugin
export default {"info":"info___r7kHY","cover":"cover___YFpd9"};